import { connect } from 'socket.io-client';

export interface Config {
  socketServer: {
    transports: string[];
    url: string;
  };
  availableWorkspaces: string[];
}

export const socketClient = (config: Config) => {
  const { transports = ['websocket'], url } = config.socketServer || {};
  const socket = connect(url, {
    transports,
  });

  socket.on('socketConnect:logout', () => {
    document.location.href = '/auth';
  });

  const oldMethod = socket.on.bind(socket);
  socket.on = (eventName: string, cb: (...args: unknown[]) => void) => {
    return oldMethod(eventName, (event: unknown, ...args: unknown[]) => {
      if (!event) {
        return cb(event, ...args);
      }
      if (typeof event === 'object' && 'workspaceId' in event) {
        const { workspaceId } = event;
        if (typeof workspaceId === 'string' && workspaceId) {
          const { availableWorkspaces } = config;
          if (!availableWorkspaces.includes(workspaceId) || eventName === 'workspace:remove') {
            return;
          }
        }
      }
      cb(event, ...args);
    });
  };
  return socket;
};
